const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL;

export const baseUrl = (configuredBaseUrl || "https://test-api.goodmove.in/api").replace(/\/$/, "");


// // export const baseUrl = "https://api.goodmove.in/api"
// export const baseUrl = "http://localhost:3002/api"
// // export const baseUrl = "https://test-api.goodmove.in/api";
